import { appointmentKeys } from 'lib/queries/appointmentKeys';
import { overviewLedgerQueryKeys } from 'lib/constants/queries/queryKeys';

export const PAYMENT_REFRESH_QUERY_KEYS = [
  appointmentKeys.invoicesAll(),
  ['patientInvoices'],
  ['patientBalance'],
  ['unallocatedPatientBalance'],
  ['transactions'],
  ['readAllocateUnAllocate'],
  ...overviewLedgerQueryKeys.map((key) => [key])
];

export const invalidatePaymentQueries = (queryClient) =>
  PAYMENT_REFRESH_QUERY_KEYS.forEach((queryKey) => queryClient.invalidateQueries({ queryKey }));

export const CATALOG_STOCK_QUERY_KEYS = [['products'], ['packages']];

export const invalidateCatalogStock = (queryClient) =>
  CATALOG_STOCK_QUERY_KEYS.forEach((queryKey) =>
    queryClient.invalidateQueries({ queryKey, refetchType: 'all' })
  );
